module.exports = {
      id: "virgo-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#virgo",
      toString: function () {
        return this.url;
      }
    }